






import { Vue, Component, Prop } from 'vue-property-decorator';
import { ParagraphSize } from '../base-paragraph';

@Component({
  name: 'BaseHelpMessage',
  data: () => ({
    ParagraphSize,
  }),
})
export default class BaseHelpMessage extends Vue {
  @Prop() message: string;
  @Prop() error: boolean;
}
